import { render, staticRenderFns } from "./Sandbox.vue?vue&type=template&id=a686c210&scoped=true&"
import script from "./Sandbox.vue?vue&type=script&lang=js&"
export * from "./Sandbox.vue?vue&type=script&lang=js&"
import style0 from "./Sandbox.vue?vue&type=style&index=0&id=a686c210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a686c210",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VContent,VList,VNavigationDrawer})
